import React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { ButtonSwitch } from 'lib/components';
import { MdMovieFilter } from 'react-icons/md';
import { billingCycles } from '../main/UpgradeContainer';

const Wrapper = styled.div`
  margin-top: 66px;
`;

const SwitchWrapper = styled.div`
  box-sizing: border-box;
  width: 167px;
  margin: 0 auto;
  position: relative;
  .remove-margin {
    margin: 0;
  }
`;

const Info = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;
const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.palette.gray80};
  margin: 0 12px 0 8px;
`;
const Badge = styled.div`
  display: inline-block;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: ${theme.palette.blue80};
  background: ${theme.palette.blue02};
  padding: 2px 4px;
`;

type Props = {
  billingCycle: string;
  onChangeBillingCycle: (billingCycle: string) => void;
};

export const Header = ({ billingCycle, onChangeBillingCycle }: Props) => {
  return (
    <Wrapper>
      <SwitchWrapper>
        <ButtonSwitch
          defaultValue={billingCycle}
          values={billingCycles}
          onChange={newValue => {
            onChangeBillingCycle(newValue);
          }}
          className='remove-margin'
        />
      </SwitchWrapper>
      <Info>
        <MdMovieFilter color={theme.palette.covideoOrange100} size={16} />
        <Text>
          All paid plans include unlimited video creation and recording up to
          1080p.
        </Text>
        <Badge>FullHD</Badge>
      </Info>
    </Wrapper>
  );
};
